"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLoadBalancer = void 0;
const createLoadBalancer = ({ httpClient, }) => ({ algorithm, droplet_ids, enable_backend_keepalive, enable_proxy_protocol, forwarding_rules, health_check, name, redirect_http_to_https, region, sticky_sessions, tag, vpc_uuid, }) => {
    const path = '/load_balancers';
    const body = {
        algorithm,
        droplet_ids,
        enable_backend_keepalive,
        enable_proxy_protocol,
        forwarding_rules,
        health_check,
        name,
        redirect_http_to_https,
        region,
        sticky_sessions,
        tag,
        vpc_uuid,
    };
    const url = `${path}`;
    return httpClient.post(url, body);
};
exports.createLoadBalancer = createLoadBalancer;
//# sourceMappingURL=create-load-balancer.js.map